<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-row>
      <v-col sm="12" md="3">
        <div class="position-relative">
          <label for>Status</label>
          <select
            v-model="status"
            @change="onStatusChange()"
            name
            id
            class="form-control"
          >
            <option value="onboarded">Onboarded</option>
            <option value="taken_subscription">Taken Subscription</option>
            <option value="onboarded_subscription_on_same_day">
              Onboarded + Taken subscription on same day
            </option>
          </select>
          <span class="drop-icon">
            <i
              aria-hidden="true"
              class="v-icon mdi mdi-menu-down theme--light position-absolute"
            ></i>
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <label for>Search</label>
        <input
          class="form-control"
          placeholder="Search"
          v-model="search"
          @input="debounceSearch()"
        />
      </v-col>
      <v-col cols="12" md="3" class="calendar-point position-relative">
        <label for>Date</label>
        <datepicker
          v-model="date"
          @input="filterDate()"
          ref="datepicker"
          :max-date="new Date()"
          is-range
          :masks="{ input: 'DD/MM/YYYY' }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input
              :value="
                !!inputValue.start && !!inputValue.end
                  ? inputValue.start + ' - ' + inputValue.end
                  : 'DD/MM/YYYY'
              "
              v-on="inputEvents.start"
              class="form-control pos-r"
              placeholder="DD/MM/YYYY"
            />
            <div
              v-if="!!inputValue.start && !!inputValue.end"
              class="cross-svg"
              @click="(date = null), getUsers()"
            >
              <crossSVG />
            </div>
          </template>
        </datepicker>
        <div class="calendarsvg userinputcalendar pos-a">
          <calendarSVG />
        </div>
        <!-- <datepicker
          v-model="date"
          @input="filterDate()"
          ref="datepicker"
          :max-date="new Date()"
          :masks="{ input: 'DD/MM/YYYY' }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input
              class="form-control pos-r"
              placeholder="DD/MM/YYYY"
              :value="inputValue"
              v-on="inputEvents"
            />
            <div
              v-if="!!inputValue"
              class="cross-svg"
              @click="(date = null), getUsers()"
            >
              <crossSVG />
            </div>
          </template>
        </datepicker> -->
        <div class="calendarsvg userinputcalendar pos-a">
          <calendarSVG />
        </div>
      </v-col>
      <v-col cols="12" md="3">
          <label for class="col-sm-12 p-0"></label>
        <v-btn class="btn btn-primary export-height mt-2" @click="getUsers(true)"
          >Export</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="table-div overflow-auto">
          <table class="table">
            <thead>
              <tr class="table-success">
                <th>DocSmart user name</th>
                <th>DocSmart user number</th>
                <th>Role</th>
                <th>Saathi Code</th>
                <th>Is onboarded</th>
                <th>Date of onboarding</th>
                <th>Is Subscribed</th>
                <th>Date of subscription</th>
                <th>Subscribed via</th>
                <th>Subscription details</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user._id">
                <td>{{ user.name }}</td>
                <td>{{ user.mobile }}</td>
                <td>Doctor</td>
                <td>{{ user.saathi_code }}</td>
                <td>Yes</td>
                <td>{{ getDate(user.date_of_onboarding) }}</td>
                <td>{{ user.is_subscribed ? "Yes" : "No" }}</td>
                <td>
                  <span v-if="user.user_subscriptions">{{
                    getDate(user.user_subscriptions.created_at)
                  }}</span>
                  <span v-else>-</span>
                </td>
                <td>{{ subscribedVia(user) }}</td>
                <td>
                  <a
                    v-if="user.user_subscriptions"
                    @click="showSubscriptionDetails(user.user_subscriptions)"
                  >
                    View</a
                  ><span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          v-if="!isEmpty"
          class="mx-6"
          :currentPage="page"
          :recordPerPage="recordsPerPage"
          :total="total"
          @changePage="changePage"
        />
      </v-col>
    </v-row>
    <v-dialog
      persistent
      v-if="showSubscriptionDetailsModal"
      v-model="showSubscriptionDetailsModal"
      width="400"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Subscription details
        </v-card-title>
        <v-card-text>
          <v-row class="mx-0 mt-0">
            <p class="mb-0 mr-2 font-weight-bold">Subscription plan name :</p>
            <p>{{ subscriptionDetail.name }}</p>
          </v-row>
          <v-row class="mx-0">
            <p class="mb-0 mr-2 font-weight-bold">Tenure :</p>
            <p>{{ subscriptionDetail.validity_text }}</p>
          </v-row>
          <v-row class="mx-0">
            <p class="mb-0 mr-2 font-weight-bold">Validity :</p>
            <p>
              {{ getDate(subscriptionDetail.activation_date) }} -
              {{ getDate(subscriptionDetail.expiration_date) }}
            </p>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="showSubscriptionDetailsModal = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import config from "@/config.js";
import debounce from "lodash/debounce";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";

export default {
  data() {
    return {
      dayJS,
      status: "onboarded",
      users: [],
      saathiCode: null,
      page: 1,
      recordsPerPage: 10,
      total: 0,
      isEmpty: true,
      showSubscriptionDetailsModal: false,
      subscriptionDetail: null,
      search: null,
      date: null,
    };
  },
  components: {
    Datepicker,
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination"),
  },
  methods: {
    filterDate() {
      this.page = 1;
      this.getUsers();
    },
    getDate(date) {
      return dayJS(date).format("DD/MM/YYYY");
    },
    onStatusChange() {
      this.page = 1;
      this.getUsers();
    },
    isSubscribed(user) {
      let flag = "Yes";
      if (!user.subscription) flag = "No";
      else if (user.subscription && user.subscription.mode_of_payment == "Free")
        flag = "Free";
      else flag = "Yes";
      return flag;
    },
    subscribedVia(user) {
      if (!user.user_subscriptions) return "-";
      if (user.user_subscriptions.source_from === "VIA_DOCSMART")
        return "Docsmart";
      else if (
        ["VIA_SEVA_USER", "VIA_DOCSMART_BY_SEVA_USER"].includes(
          user.user_subscriptions.source_from
        )
      )
        return "SEVA";
    },
    debounceSearch: debounce(function () {
      this.page = 1;
      this.isEmpty = true;
      this.getUsers();
    }, 500),
    changePage(page) {
      this.page = page.currentPage;
      this.getUsers();
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    getUsers(isExport = false) {
      let params = {
        status: this.status,
        records_per_page: this.recordsPerPage,
        page: this.page,
        search: this.search,
        is_export: isExport,
      };
      if (this.date) {
        params.start_date = new Date(this.date.start).toISOString();
        params.end_date = new Date(this.date.end).toISOString();
      }
      let url = `${config.BASE_URL}api/v2/admin/seva/doctor/user-by-seva`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (isExport) {
            this.download(response.data.data.fileName, response.data.data.csv);
          } else {
            if (response.body.data.total > 0) this.isEmpty = false;
            else this.isEmpty = true;
            this.page = response.body.data.page;
            this.recordsPerPage = response.body.data.limit;
            this.total = response.body.data.count;
            this.users = response.body.data.list;
          }
        }
      });
    },
    showSubscriptionDetails(subscription) {
      this.subscriptionDetail = subscription;
      this.showSubscriptionDetailsModal = true;
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>